import { FC, ReactNode } from 'react';
import { Tooltip } from '@mui/material';
import { InvoiceSummaryDto } from 'src/generated/services/TFinancialApi';
import { useUserContext } from 'src/use-cases/user/userDetails';
import IconReceipt from 'src/assets/images/icons/card-edit-2.svg';
import ViewRatecardIcon from 'src/assets/images/icons/document-code-2.svg';
import { useShipmentSelector } from '../../../ShipmentSelector';

/**
 * Component to render deviation-specific actions like rate card access
 * Extracted from ProcurementDecision component's moreActions logic
 */
interface DeviationActionsProps {
  invoiceSummary: InvoiceSummaryDto;
  onDownloadConfiguredRateCard?: () => void;
  additionalActions?: ReactNode;
}

export const DeviationActions: FC<DeviationActionsProps> = ({ invoiceSummary, onDownloadConfiguredRateCard, additionalActions }) => {
  const { shipment } = useShipmentSelector();
  const { userDetails, isLoading: isUserLoading } = useUserContext();

  // Rate card access logic
  const isSpotShipment = shipment?.status === 'SPOT_SHIPMENT';
  const allowedRoles = new Set(['Procurement Manager', 'Finance', 'Supply Chain']);
  const isHaveAccessRateCard = !isUserLoading && userDetails?.admin && allowedRoles.has(userDetails?.displayRole || '') && !isSpotShipment;

  return (
    <>
      {additionalActions}

      {/* Rate Card Manager Access */}
      {isHaveAccessRateCard && (
        <Tooltip
          title='Open Rate Card Manager'
          arrow
          placement='bottom'
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: '#000',
                color: 'white',
                '& .MuiTooltip-arrow': {
                  color: '#000',
                },
              },
            },
          }}
        >
          <button
            type='button'
            onClick={() =>
              window.open(
                `/ratecard-manager?service-provider=${invoiceSummary?.serviceProvider}&modality=${invoiceSummary?.modality}&shipping_service=${shipment?.shippingServiceId}&contract=${shipment?.contractId}`,
                '_blank'
              )
            }
            className='w-36 h-36 flex items-center justify-center border border-neutral-20 rounded-lg bg-white hover:bg-neutral-5'
          >
            <img src={IconReceipt} alt='Rate Card Manager' className='w-24 h-24' />
          </button>
        </Tooltip>
      )}

      {/* View Configured Rate Card */}
      {!isSpotShipment && (
        <Tooltip
          title='View Configured Rate Card'
          arrow
          placement='bottom'
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: '#000',
                color: 'white',
                '& .MuiTooltip-arrow': {
                  color: '#000',
                },
              },
            },
          }}
        >
          <button
            type='button'
            onClick={onDownloadConfiguredRateCard}
            className='w-36 h-36 flex items-center justify-center border border-neutral-20 rounded-lg bg-white hover:bg-neutral-5'
          >
            <img src={ViewRatecardIcon} alt='View Rate Card' className='w-24 h-24' />
          </button>
        </Tooltip>
      )}
    </>
  );
};
